export function capitalize(val: string) {
  return (val.length && val.charAt(0).toUpperCase() + val.slice(1)) || '';
}
